import { inject, Injectable } from '@angular/core';
import { SessionTokens } from '../../enums/session-tokens.enum';
import { CurrentUserInfo } from '../../interfaces/current-user-info.interface';
import { EncryptionService } from '../encryption/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  private encryptionService = inject(EncryptionService);

  constructor() { }

  // Clear Session Storage
  public clearSessionStorage() {
    sessionStorage.clear();
  }

  // CURRENT_USER_INFO
  public setCurrentUserInfo(currentUserInfo: CurrentUserInfo) {
    const cipher: string = this.encryptionService.encrypt(JSON.stringify(currentUserInfo));
    // sessionStorage.setItem(SessionTokens.CURRENT_USER_INFO, JSON.stringify(currentUserInfo));
    sessionStorage.setItem(SessionTokens.CURRENT_USER_INFO, cipher);
  }

  public getCurrentUserInfo(): CurrentUserInfo {
    const cipher: string = sessionStorage.getItem(SessionTokens.CURRENT_USER_INFO)?.toString() || "";
    // return JSON.parse(sessionStorage.getItem(SessionTokens.CURRENT_USER_INFO)?.toString() || '{}');
    const dataString: string = this.encryptionService.decrypt(cipher);

    return JSON.parse(dataString || '{}');
  }

  // Get Current Rep Code
  public getCurrentRepCode(): string {
    const currentUserInfo: CurrentUserInfo = this.getCurrentUserInfo();
    return currentUserInfo.repCode;
  }

  // Get Current User Email
  public getCurrentUserEmail(): string {
    const currentUserInfo = this.getCurrentUserInfo();
    return currentUserInfo.email;
  }

  // Get Current User AuthToken
  public getCurrentUserAuthToken(): string {
    const currentUserInfo = this.getCurrentUserInfo();
    return currentUserInfo.authToken;
  }

  // Get Current User Person Name
  public getCurrentUserPersonName(): string {
    const currentUserInfo = this.getCurrentUserInfo();
    return currentUserInfo.personName;
  }

  // Get Current User Role
  public getCurrentUserRole(): string {
    const currentUserInfo = this.getCurrentUserInfo();
    return currentUserInfo.userRole;
  }

  // Get Current User Access Token
  public getCurrentUserAccessToken(): string {
    const currentUserInfo = this.getCurrentUserInfo();
    return currentUserInfo.accessToken;
  }

  // Get Current User Group
  public getCurrentUserGroup(): string {
    const currentUserInfo = this.getCurrentUserInfo();
    return currentUserInfo.userGroup;
  }

}
